import Login from "@/pages/Login";
import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { safeRedirect } from "@/lib/postLoginHome";

const LoginRoute = () => <Login />;

export const Route = createFileRoute("/login")({
  component: LoginRoute,
  // Accept a ``?redirect`` so the unauth fallback in __root/PortalLayout can
  // bounce a logged-out user to /login and return them post-login.
  validateSearch: (s: Record<string, unknown>): { redirect?: string } => ({
    redirect: safeRedirect(s.redirect),
  }),
});
